import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../../../app/store';

export type SchneiderChargeSetupState = {
  bearerToken: string | null;
};

const initialState: SchneiderChargeSetupState = {
  bearerToken: null,
};

export const schneiderChargeSetupSlice = createSlice({
  name: 'schneiderChargeSetup',
  initialState,
  reducers: {
    addBearerToken: (state, action: PayloadAction<string>) => {
      return { ...state, bearerToken: action.payload };
    },
    resetSchneiderChargeSetup: () => {
      return { ...initialState };
    },
  },
});

export const { resetSchneiderChargeSetup, addBearerToken } = schneiderChargeSetupSlice.actions;

export const selectBearerToken = (state: RootState) => {
  return state.schneiderChargeSetup.bearerToken;
};

export const { reducer: schneiderChargeSetupReducer } = schneiderChargeSetupSlice;
